// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__3UWOW","iframe":"styles_iframe__H_UwA"};